<div id="update-notification" *ngIf="isChanged">
  <span class="notificationTitle">更新通知：</span>
  <span>{{ msg }}</span>
  <button class="ok-button" (click)="reload()">今すぐ{{ btnMsg }}</button>
</div>
